import _keys from "lodash/keys";
import _find from "lodash/find";
import _has from "lodash/has";
import _isString from "lodash/isString";
import _isUndefined from "lodash/isUndefined";
import _isArray from "lodash/isArray";
import compareSemvers from './lib/compare-semvers'; // TODO: validation methods and errors should be moved to
// the tree-utils file
// eslint-disable-next-line import/no-cycle

import walk, { transform } from './lib/tree-utils';
import stringifyNode from './lib/stringify-node';
import { ValidationError, MigrationError } from './errors'; // this module throws ValidationError and MigrationError, so re-export them from here

export { ValidationError, MigrationError }; // TODO: move the validation related functions and errors into tree-utils

function isNodeValid(node, schema) {
  if (_isArray(node)) return true;
  if (_isUndefined(node)) throw new ValidationError(node);
  var type = node.type,
      nodeVersion = node.version;
  if (!_isString(type)) throw new ValidationError(node);
  if (!_isString(nodeVersion)) throw new ValidationError("node must define version as semver >= 1.0.0, got: ".concat(nodeVersion));
  if (!_has(schema, type)) throw new ValidationError("schema has no definition for type: '".concat(type, "'"));
  var schemaVersion = schema[type].version;
  if (nodeVersion === schemaVersion) return true;
  return false;
}

export function validateNode(node, key, schema) {
  var valid = false;

  try {
    valid = isNodeValid(node, schema);
  } catch (err) {
    throw new ValidationError("".concat(err.message, ", at path: ").concat(key));
  }

  if (valid === false) {
    throw new ValidationError("".concat(stringifyNode(node), ", at path: ").concat(key));
  }
}
export function validate(node, schema) {
  if (!_isArray(node) && (!_has(node, 'type') || !_has(node, 'props'))) {
    throw new ValidationError("Invalid structured document. ".concat(stringifyNode(node)));
  }

  return walk(node, schema, function () {});
}
export function isValid(node, schema) {
  try {
    validate(node, schema);
  } catch (err) {
    if (err instanceof ValidationError) return false;
    throw err;
  }

  return true;
}

function assertMigrationValid(migratedNode, targetVersion, startType, startVersion) {
  if (startType !== migratedNode.type) return migratedNode; // migrator changed the node type

  if (targetVersion === migratedNode.version) return migratedNode; // migrator correctly changed the version

  throw new MigrationError("migrator version ".concat(targetVersion, " for type: ").concat(startType, " failed to migrate node from version ").concat(startVersion, " to ").concat(targetVersion, " (got: ").concat(migratedNode.version, ")"));
}

var migrateNode = function migrateNode(node, key, schema) {
  // node is at target version defined in schema. recurse down.
  if (isNodeValid(node, schema)) return node; // node is not at target version.  migrators need to be run

  var type = node.type; // Default all falsey versions to `0.0.0`

  var version = node.version || '0.0.0';
  var _schema$type = schema[type],
      migrations = _schema$type.migrations,
      schemaVersion = _schema$type.version; // time to run the next migrator on this node

  var targetVersion = _find(_keys(migrations), function (migratorVersion) {
    return compareSemvers(version, migratorVersion) === -1;
  });

  if (_has(migrations, targetVersion)) {
    // get the migrator
    var migrator = migrations[targetVersion]; // run the migrator on the node

    var migrated = migrator(node, schema); // ensure migrator ran successfully

    assertMigrationValid(migrated, targetVersion, type, version); // keep running until node version matches schema version

    return migrateNode(migrated, key, schema);
  }

  throw new MigrationError("Cannot migrate node down. Node { type: ".concat(type, ", version: ").concat(version, " }. Schema version: ").concat(schemaVersion));
};

export default function migrate(node, schema) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$mutate = _ref.mutate,
      mutate = _ref$mutate === void 0 ? false : _ref$mutate;

  return transform(node, schema, migrateNode, {
    mutate: mutate
  });
}